module.exports = __webpack_public_path__ + "static/media/pets-using-door.c15d6574.png";